<div class="survey-page-wrapper">
    <div class="survey-container" *ngIf="survey as s">
      <div class="survey-header">
        <div class="header-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4a90e2" class="bi bi-person-fill-gear" viewBox="0 0 16 16">
            <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.643a7.38 7.38 0 0 1-.497-1H4c0-.01 0-.1 0-.222.003-.242.148-.644.4-.99.482-.674 1.111-1.135 1.761-1.574-.68-.165-1.34-.373-1.958-.649-1.067-.45-1.715-1.2-1.715-2.149L7.618 8.87a6.936 6.936 0 0 0-.293 1h-2.61a.25.25 0 0 0-.25.25V13Zm8.862-5.65c.54.028 1.05.118 1.527.279l.103.048a.85.85 0 0 1 .14.076c.415.22.747.534.986.91.28.461.27.994.04 1.533a11 11 0 0 1-.36 1.053c-.354.914-.853 1.956-1.53 3.012a.5.5 0 0 1-.954-.321c.542-.9.982-1.916 1.253-2.687.308-.8.497-1.546.59-2.22c.03-.22.04-.45.04-.683 0-.155-.005-.308-.013-.458a.798.798 000-.145-.068.798.798 000-.097.054.798.798 000-.125-.067.798.798 000-.142-.09c-.27-.152-.587-.27-.923-.32-.089-.013-.18-.021-.271-.029.07-.179.16-.353.273-.51h.002Z"/>
            <path d="M14.293 14.707a1 1 0 0 1-1.414-1.414L14.586 11H14.5a.5.5 0 0 1 0-1h.5a.5.5 0 0 1 0 1h-.086l-1.603-1.603a.5.5 0 0 1 .707-.707L14.793 10H15.5a.5.5 0 0 1 0 1h-.707l1.603 1.603a.5.5 0 0 1-.707.707Z"/>
          </svg>
        </div>
        <h2>{{ s.title }}</h2>
        <p>{{ s.description }}</p>
      </div>
  
      <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
        <div *ngFor="let question of s.questions" class="question-group">
          <label [for]="question.id">{{ question.text }}</label>
  
          <div *ngIf="question.type === 'text'">
            <input type="text" [id]="question.id" [formControl]="getQuestionControl(question.id)" class="form-control" placeholder="Escribe tu respuesta aquí...">
          </div>
  
          <div *ngIf="question.type === 'textarea'">
            <textarea [id]="question.id" [formControl]="getQuestionControl(question.id)" class="form-control" rows="4" placeholder="Comparte tus comentarios..."></textarea>
          </div>
  
          <div *ngIf="question.type === 'radio'">
            <div *ngFor="let option of question.options" class="form-check">
              <input type="radio"
                     [id]="question.id + '-' + option.value"
                     [name]="question.id"
                     [value]="option.value"
                     [formControl]="getQuestionControl(question.id)"
                     class="form-check-input">
              <label [for]="question.id + '-' + option.value" class="form-check-label">{{ option.label }}</label>
            </div>
          </div>
  
          <div *ngIf="question.type === 'select'">
            <select [id]="question.id" [formControl]="getQuestionControl(question.id)" class="form-select">
              <option [value]="null" disabled selected>Selecciona una opción</option>
              <option *ngFor="let option of question.options" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
  
          <div *ngIf="question.type === 'checkbox'" [formGroup]="getCheckboxGroup(question.id)">
            <div *ngFor="let option of question.options" class="form-check">
              <input type="checkbox"
                     [id]="question.id + '-' + option.value"
                     [formControlName]="option.value"
                     class="form-check-input">
              <label [for]="question.id + '-' + option.value" class="form-check-label">{{ option.label }}</label>
            </div>
          </div>
        </div>
  
        <button type="submit" class="submit-button" [disabled]="isSubmitting">
          <span *ngIf="!isSubmitting">Enviar Información</span>
          <span *ngIf="isSubmitting">
            <span class="loading-spinner"></span> Enviando...
          </span>
        </button>
      </form>
    </div>
  
    <div *ngIf="!survey" class="loading-message">
      <p>Cargando encuesta o encuesta no encontrada...</p>
    </div>
  </div>